import { createFileRoute } from '@tanstack/react-router';
import { HomeGate } from '@/features/account/shell/HomeGate';
import ModulePage from '@/features/modules/module-page';
import { ensureOnboardingProgressLoaded } from '@/features/account/onboarding/shared/ensure-onboarding-progress.loader';
import { moduleSearchSchema } from '@/features/modules/shared/module-search.schema';

/**
 * Generic module route. The `moduleId` segment is the journey-stage id; the
 * `vagaId` search param scopes the lookup. Every module the recruiter draws
 * in the journey lands here — there are no per-module routes anymore.
 *
 * Coexistência: as etapas legadas têm rota própria aninhada
 * (`/vagas/$jobId_/processo_/$moduleId`), então esta rota é só v2.
 */
export const Route = createFileRoute('/modulos/$moduleId')({
  validateSearch: moduleSearchSchema,
  component: () => (
    <HomeGate>
      <ModulePage />
    </HomeGate>
  ),
  loader: ({ context }) => ensureOnboardingProgressLoaded(context),
});
